export default "__VITE_ASSET__Cv6aEya$__"